import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

/**
 * TODO:
 */
export const applyEdits = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    feature.actions.applyEdits.relay((forwardTo, { target }) =>
      plugin.edited.selectors.getFromSelectionLookup(target).asObservable.pipe(
        rxjs.take(1),
        rxjs.mergeMap(ids => [
          // Apply that selection
          forwardTo(plugin.applied.actions.putInSelectionLookup, {
            input: { key: target, value: { set: ids } },
          }),
          // Clear that selection from edits
          forwardTo(plugin.edited.actions.putInSelectionLookup, {
            input: { key: target, value: { release: true } },
          }),
        ]),
      ),
    ).asObservable,
)
